import { useIntl } from "react-intl";
function Header() {
  const intl = useIntl();
  return (
    <header className="fixed top-0 z-21 m-auto w-full text-center">
      <nav className="600:h-[90px] 600:pl-[35px] z-1 m-auto flex h-[60px] items-center justify-between border-b border-solid border-[#e5e5e5] bg-white py-[31px] pr-5 pl-5 text-center">
        <div className="flex-1">
          <div className="z-20 w-fit">
            <img
              src="/account-auth/images/NewsGuardLogo_SMALL-Black.svg"
              alt={intl.formatMessage({
                id: "auth.logoAlt",
                defaultMessage: "NewsGuard Logo",
              })}
              className="600:w-[185px] w-[132px]"
            />
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
